import React, { useEffect, useId } from 'react';
import { Link } from 'react-router-dom';
import I3RichHtml from './I3RichHtml';
import '../styles/I3Modal.css';

const CONTACT = '/contact';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  detailHtml: string;
  bookUrl: string;
};

/**
 * Per-service “Details” modal (not the global home-page pillar modals).
 */
const I3ServiceDetailDialog: React.FC<Props> = ({ open, onClose, title, detailHtml, bookUrl }) => {
  const titleId = useId().replace(/:/g, '');

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="i3-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={`i3-svc-modal-${titleId}`}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="i3-modal i3-modal--service">
        <div className="i3-modal-header">
          <h2 id={`i3-svc-modal-${titleId}`} className="i3-modal-title">
            {title}
          </h2>
          <button type="button" className="i3-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div
          className="i3-modal-body"
          onClick={(e) => {
            if ((e.target as HTMLElement).closest('a')) onClose();
          }}
        >
          <I3RichHtml html={detailHtml} />
          <div className="i3-modal-actions">
            {bookUrl ? (
              <a
                href={bookUrl}
                className="i3-cta i3-cta-primary"
              >
                Book
              </a>
            ) : (
              <Link to={CONTACT} className="i3-cta i3-cta-primary">
                Book
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default I3ServiceDetailDialog;
